import { ArrowRight } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_BUTTON_ATTRS, goToCheckout } from '../utils/checkout';
interface PurchaseButtonProps {
  label?: string;
  emoji?: string;
  className?: string;
}
export function PurchaseButton({
  label = 'QUIERO MI FÚTBOL FEMENINO RESUELTO AHORA',
  emoji,
  className = ''
}: PurchaseButtonProps) {
  return <Button {...CHECKOUT_BUTTON_ATTRS} type="button" size="lg" onClick={goToCheckout} className={`group box-border h-auto min-h-14 w-full max-w-full justify-center overflow-hidden whitespace-normal rounded-xl border border-green-300/30 bg-brandgreen px-4 py-4 font-heading text-sm font-black leading-tight text-navy shadow-[0_12px_30px_rgba(34,197,94,0.24)] transition duration-200 ease-out hover:-translate-y-0.5 hover:bg-brandgreen-hover hover:text-white focus-visible:ring-brandgreen motion-reduce:transform-none motion-reduce:transition-none sm:w-auto sm:px-8 sm:text-base ${className}`} data-id="element-147" data-mp="327ourtsgnpa">
      {emoji && <span className="shrink-0 text-base sm:text-lg" aria-hidden="true" data-id="element-148" data-mp="1ehe5tuukvu4z">{emoji}</span>}
      <span className="min-w-0 max-w-full text-center [text-wrap:balance]" data-id="element-149" data-mp="rv2yhz1jzebn">{label}</span>
      <ArrowRight className="shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1 motion-reduce:transform-none motion-reduce:transition-none" size={19} strokeWidth={2.6} aria-hidden="true" data-id="element-150" data-mp="mzw0n7uyt3un" />
    </Button>;
}